import React, { memo } from 'react';
import { BulbOutlined, PictureOutlined, ThunderboltOutlined, BranchesOutlined } from '@ant-design/icons';

const features = [
  {
    icon: <PictureOutlined className='feature-icon' />, // distinct icon for generation
    title: 'Generate Images & Videos',
    description: 'Create high-quality visuals in seconds with our powerful diffusion models.',
  },
  {
    icon: <BulbOutlined className='feature-icon' />, // prompt refinement
    title: 'AI-Assisted Prompting',
    description: 'Get smart suggestions that turn your ideas into perfect prompts.',
  },
  {
    icon: <BranchesOutlined className='feature-icon' />, // workflows
    title: 'Automated Workflows',
    description: 'Chain tasks together—generate, upscale, and publish with one call.',
  },
];

const FeaturesSection = () => {
  const renderFeature = (feature) => {
    return (
      <div
        key={feature.title}
        className='bg-gradient-to-br from-[#28284a] to-[#18181b] rounded-2xl p-7 flex flex-col items-center text-center border border-white/10 transition-all duration-200 hover:z-10 focus:ring-2 focus:ring-[#5a4bff] focus:outline-none'
        tabIndex={0}
        aria-label={feature.title}
      >
        <div className='text-4xl mb-4 text-[#5a4bff]'>{feature.icon}</div>
        <h3 className='text-xl font-semibold mb-2 text-white'>{feature.title}</h3>
        <p className='text-gray-300 text-base'>{feature.description}</p>
      </div>
    );
  };
  return (
    <section id='features' className='pt-20'>
      <h2 className='text-4xl font-bold text-center mb-12 text-white tracking-tight'>What Makes Uro Powerful</h2>
      <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8  mx-auto'>
        {features.map((f) => (
          renderFeature(f)
        ))}
      </div>
    </section>
  );
};

export default memo(FeaturesSection);